<template >
  <div class="CustomizeOffer" v-if="show" :class="{ loading: loading > 0 }">
    <div class="subtitle" v-if="userRooms.length > 1">
      {{ tran("ROOM_INDEX", { room: run("get", "currentUserRoomIndex") + 1 }) }}
    </div>
    <h2 class="title">{{ tran("CUSTOMIZE_OFFER_TITLE") }}</h2>
    <div class="offer-items items" v-if="items">
      <div class="offer-item item" v-for="(item, index) in items" :key="index">
        <div class="wrapper">
          <div class="image">
            <img v-if="item.image" :src="item.image" />
            <div class="title" v-html="item.title"></div>
          </div>
          <div class="desc">
            <div class="description" v-html="item.description"></div>
            <div class="price" v-html="item.price"></div>
            <div class="price-note" v-html="item.price_note"></div>
          </div>
          <button
            id="ugprade-click"
            type="button"
            class="btn"
            :class="item.buttonClass"
            @click.prevent="select(item)"
          >
            {{ tran("SELECT_CONTINUE") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomizeOffer",
  components: {},
  props: {
    run: Function,
  },
  data: function () {
    return {
      loading: 0,
      items: false,
    };
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "customize_trip");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    currentUserRoomIndex() {
      return this.run("get", "currentUserRoomIndex");
    },
    userRooms() {
      return this.run("get", "rooms");
    },

    nextRoomIndex() {
      let nextRoomIndex = this.userRooms.length;
      for (const roomIndex in this.userRooms) {
        const room = this.userRooms[roomIndex];
        if (
          !room.userChooseRoom ||
          !room.roomNumber ||
          !room.category ||
          !room.categoryType
        ) {
          nextRoomIndex = roomIndex;
        }
      }
      if (this.currentUserRoomIndex > nextRoomIndex) {
        return nextRoomIndex;
      }
      if (this.currentUserRoomIndex < this.userRooms.length - 1) {
        return this.currentUserRoomIndex + 1;
      }
      return -1;
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {
      if (!this.run("get", "config.isDev", false)) {
        if (this.run("stepDirection") == "prev") {
          this.run("prev");
        } else {
          this.run("next");
        }
        return;
      }
      this.fetch();
    },
    onHide: function () {},
    async fetch() {
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const roomIndex = this.run("get", "currentUserRoomIndex");
      const room = rooms[roomIndex];
      if (!room.categoryType || !room.roomNumber) {
        return;
      }
      this.loading++;
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getOffers",
        { rooms, numberOfRoom, roomIndex }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        return;
      }
      this.items = res.data.items;

      this.loading--;
    },
    select(item) {
      this.run(
        "set",
        "rooms." + this.currentUserRoomIndex + ".offer",
        item.value
      );
      // if (this.nextRoomIndex != -1) {
      //   this.run("set", "currentUserRoomIndex", this.nextRoomIndex);
      //   return;
      // }
      this.run("next");
    },
    prev(step) {
      let cabinHold = false;
      for (const room of this.userRooms) {
        if (room.cabinHold && !room.guarantee) {
          cabinHold = true;
          break;
        }
      }
      if (cabinHold && this.run("get", "unholdSilent") != true) {
        this.run(
          "popupConfirm",
          this.tran("CONFIRM_UNHOLD_CABIN_MESSAGE"),
          async () => {
            await this.unHoldCabins();
            if (step != undefined) {
              this.run("goStep", step);
            }
          }
        );

        return false;
      } else if (cabinHold) {
        setTimeout(async () => {
          await this.unHoldCabins();
          this.run("set", "unholdSilent", false);
          if (step != undefined) {
            this.run("goStep", step);
          }
        }, 10);
        return false;
      }
      return true;
    },
    async unHoldCabins() {
      this.run("showLoading");
      const rooms = this.run("rooms");
      const ship = this.run("ship");

      await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".cabinUnHold",
        {
          rooms,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      for (const room of rooms) {
        room.cabinHold = false;
      }

      this.run("hideLoading");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
